module.exports = __webpack_public_path__ + "img/building-green.0fcda543.png";